import LinkNext from 'next/link';
import NotificationItemContent from './NotificationItemContent';

interface NotifItem {
  created?: string;
  type?: string;
  data?: any;
  is_read: boolean;
  id: number;
}

interface NotificationItemProps {
  item: NotifItem;
  onClickConversationNotif: ({
    visible,
    id,
  }: {
    visible: boolean;
    id: number;
  }) => void;
}

function NotificationItem({
  item,
  onClickConversationNotif,
}: NotificationItemProps) {
  const { data: messageData } = item;
  const { type } = item;
  const maskKey = 'message_mask';
  const linkToKey = 'link_to';
  let mask = messageData[maskKey] || [];

  const attrs = { href: '', onClick: null };

  let message = messageData?.message || '';

  switch (type) {
    case 'NOTIF_TYPE_MENTIONS': // Mention
    case 'NOTIF_TYPE_NEW_REPORT': // Report
    case 'NOTIF_TYPE_LIKE': // Activity
    case 'NOTIF_TYPE_STREAMS_UPDATE': // Activity
    case 'NOTIF_TYPE_POSTALERT': // Activity
    case 'NOTIF_TYPE_SAVE': // Save
    case 'NOTIF_TYPE_RETWEET': // Repost
    case 'NOTIF_TYPE_NEWSFEED':
    case 'NOTIF_TYPE_COMPANY_PUBLIC_EXPOSE':
    case 'NOTIF_TYPE_COMPANY_SHAREHOLDING':
    case 'NOTIF_TYPE_COMPANY_DIVIDEND':
    case 'NOTIF_TYPE_COMPANY_CORP_ACTION':
    case 'NOTIF_TYPE_COMPANY_OTHERS':
      attrs.href = `/post/${messageData[linkToKey].value}`;
      break;
    case 'NOTIF_TYPE_REPLY': // Activity
      attrs.onClick = () =>
        onClickConversationNotif({
          visible: true,
          id: messageData[linkToKey].value,
        });
      break;
    case 'NOTIF_TYPE_FOLLOWING': // Follow
      attrs.href = `/${messageData[linkToKey].value}`;
      break;
    case 'NOTIF_TYPE_TIPPING_RECEIVER':
    case 'NOTIF_TYPE_TIPPING_SENDER':
    case 'NOTIF_TYPE_CLAIM':
      attrs.href = `/tip/${messageData[linkToKey].value}`;
      break;
    case 'NOTIF_TYPE_TRADING_MATCH_ORDER':
      attrs.href = '/trade/portofolio/';
      break;
    case 'NOTIF_TYPE_TRADING_COMMUNITY':
      attrs.href = `/community/?search=${messageData[linkToKey].value}`;

      if (!mask || mask.length <= 0) {
        message = `[%username-mask%] ${message}`;
        mask = [
          {
            key: 'username-mask',
            payload: {
              actors: [],
              id: 0,
              tag: 'PAYLOAD_MASK_TAG_BOLD',
              text: messageData[linkToKey].value,
              type: 'PAYLOAD_MASK_TYPE_USER',
            },
          },
        ];
      }

      break;
    case 'NOTIF_TYPE_NEW_TRENDING': // Trending
      attrs.href = `/symbol/${messageData[linkToKey].value}`;
      break;
    case 'NOTIF_TYPE_SECURITIES_DAY_TRADE': // Day Trade
    case 'NOTIF_TYPE_SHARIA_STOCK_DELISTED': // Sharia Stock Delisted
      attrs.href = '/securities/portfolio';
      break;
    default:
      // NOTIF_TYPE_STOCK_ALERT => Cannot Clicked
      attrs.href = '';
      break;
  }

  if (attrs.href !== '') {
    return (
      <LinkNext href={attrs?.href} passHref>
        <a>
          <NotificationItemContent
            isNew={!item.is_read}
            avatar={messageData?.avatar}
            created={item?.created}
            message={message}
            mask={mask}
            type={item?.type}
          />
        </a>
      </LinkNext>
    );
  }
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      onClick={attrs.onClick}
      role="menuitem"
      tabIndex={-1}
      style={{
        cursor: attrs.onClick !== null ? 'pointer' : 'unset',
      }}
    >
      <NotificationItemContent
        isNew={!item.is_read}
        avatar={messageData?.avatar}
        created={item?.created}
        message={message}
        mask={mask}
        type={item?.type}
      />
    </div>
  );
}

export default NotificationItem;
